import { theme } from '@acorns/web-components'
import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;

  @media (min-width: ${theme.breakpoints.sm + 1}px) {
    max-width: 340px;
  }
`

export const Text = styled.span`
  text-align: left;
  color: ${theme.colors.stone};
  font-size: 12px;
  line-height: 16px;

  @media (min-width: ${theme.breakpoints.sm + 1}px) {
    width: 306px;
  }
`
